import SocialMediaSection from "./SocialMediaSection";

export default SocialMediaSection;
